import React, {useEffect, useRef, useState} from 'react';
import './index.css';
import TabSection from '../../components/tabsection/index';
import {Field, Form, Formik} from 'formik';
import {Trans, useTranslation} from 'react-i18next';
import {history} from '../../../../utils/redux/store';
import skinDetectionCategories from '../../../../utils/config/skinDetectionCategories';
import _get from 'lodash/get';
import RadioButton from '../../../../components/formik/RadioButton';
import CustomSwitch from '../../../../components/layout/CustomSwitch';
import ImageField from '../../../../components/formik/ImageField';
import SkinResultPageFooter from './footer';
import ColorField from '../../../../components/product/color/colorfield';
import SelectBox from '../../../../components/formik/SelectBox';
import skinResultPageStyle from '../../../../utils/config/skinResultPageStyle';
import {toast} from 'react-toastify';
import {useSelector} from 'react-redux';
import PreviewModule from '../../components/previewmodule';
import Header from '../../components/header';
import ButtonWithRestoreGroup from '../../../../components/formik/ButtonWithRestoreGroup';
import {
  handleImage,
  getBrandId,
  zipGenerate,
  getTemplateDefaultConfig,
  mappingDisable,
  arrayMappingValue,
  getTemplate,
  getTemplateLayout,
  updateTemplate,
} from '../../../../utils/skincareUtils';
import templateConfigs from '../config/utils/templateUtils';
import Loader from '../../../../components/spinner/Loader';
import UnSavedModal from '../../components/unSavedModal';
import useWindowWidth from '../../../../components/hook/useWindowWidth';
import classnames from 'classnames';
import config from '../config/utils/contentUtils';
import cookieUtils from '../../../../utils/cookieUtils';
import SkinReport from './skinreport';
import Recommendation from './recommendation';
import smbUtils from '../../../../utils/smbUtils';
import PublishToOnlineModal from '../components/PublishToOnlineModal';
import {privilegeUtils} from '../../../../utils/privilegeUtils';
import langUtils from '../../../../utils/langUtils';

export default function SkinResultPage() {
  const width = useWindowWidth();
  const [initValue, setInitValue] = useState({});
  const accountSummary = useSelector(
    state => state.components.auth.accountSummary
  );
  const formRef = useRef();
  const [isLoaded, setIsLoaded] = useState(true);
  const {t} = useTranslation();
  const {token, customerId, brandInfo} = smbUtils.customerInfo(accountSummary);
  const [revisionId, setRevisionId] = useState();
  const [detectionRvId, setDetectionRvId] = useState();
  const [template, setTemplate] = useState();
  const [templateType, setTemplateType] = useState('ResultHomePage');
  const [templateId, setTemplateId] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [publishStatus, setPublishStatus] = useState(false);
  const [isShowPublishModal, setIsShowPublishModal] = useState(false);
  const [theme, setTheme] = useState('');
  const [showDialog, setShowDialog] = useState(false);
  const [lightData, setLightData] = useState();
  const [darkData, setDarkData] = useState();
  const [isFirst, setIsFirst] = useState(true);
  const [hidePreview, setHidePreview] = useState(false);
  const appLang = langUtils
    .getAppLangList()
    .find(l => l.value === cookieUtils.getCookie('appLang'));
  let displayRecommendLayout = [];
  const [imageType, setImageType] = useState('pad');
  const [category, setCategory] = useState([]);

  useEffect(() => {
    if (_get(brandInfo, 'templateVersion') === 2) {
      history.push('/skincare-pro/ui-configuration/skin-result');
    }
    getBrandId(token, customerId).then(res => {
      if (res && _get(res, 'resultPageRvId', '')) {
        setRevisionId(_get(res, 'resultPageRvId', ''));
        setDetectionRvId(_get(res, 'skincareDetectionRvId', ''));
      }
    });
  }, []);

  const handleRestore = mode => {
    getTemplateDefaultConfig(
      'SmbResultHomePage',
      mode.replace(mode[0], mode[0].toUpperCase()),
      1,
      customerId
    ).then(r => {
      if (r && r.templateMetadata && r.fileId) {
        let data = r.templateMetadata;
        setTemplate(data);
        setInitValue(data.langs[0].page);
        updateTemplate(
          token,
          customerId,
          templateId,
          templateType,
          data,
          r.fileId
        ).then(r => {
          setPublishStatus(!publishStatus);
          toast.success(
            <Trans i18nKey="c.f.simple.button.group.success">success</Trans>
          );
        });
      }
    });
  };

  useEffect(() => {
    if (revisionId && detectionRvId) {
      getTemplateLayout(
        token,
        customerId,
        'SmbSkincareResultPage',
        _get(brandInfo, 'templateVersion')
      ).then(res => {
        if (res) {
          setPreviewUrl(res.indexPage);
        }
      });

      getTemplate(token, customerId, revisionId, templateType)
        .then(res => {
          if (res && res.metaDataJson) {
            let data = JSON.parse(res.metaDataJson);
            setTemplate(JSON.parse(res.metaDataJson));
            setInitValue(data.langs[0].page);
            setTheme(data.langs[0].page.templateStyle);
          }
          setTemplateId(_get(res, 'templateId', ''));
          setTemplateType(_get(res, 'templateType', ''));
        })
        .then(() => setIsLoaded(false));

      getTemplate(token, customerId, detectionRvId).then(res => {
        if (res) {
          const detectionData = JSON.parse(_get(res, 'metaDataJson', ''));
          setCategory(
            _get(detectionData, 'isShowSkinHealth', false)
              ? [
                  'skin_health',
                  ..._get(detectionData, 'sequenceOfCategory', []),
                ]
              : _get(detectionData, 'sequenceOfCategory', [])
          );
        }
      });
    }
  }, [revisionId, detectionRvId]);

  const handleEnabledInfo = (infoArray = []) => {
    return infoArray.indexOf('brandName') > -1
      ? ['brandName', 'productName', 'productDesc']
      : ['productName', 'productDesc'];
  };

  const getInitValue = values => {
    const v = values || {};
    const layout = _get(v, 'skincareHtmlResult.recommendSummary.layout', []);
    const array =
      layout.length > 0
        ? layout.map(({value}) => value)
        : ['productRecommend', 'treatmentRecommend', 'routineRecommend'];
    const sequenceOfRecommendLayout = mappingDisable(
      array,
      skinDetectionCategories.getSkinRecommendLayout()
    );
    displayRecommendLayout =
      sequenceOfRecommendLayout.length > 0 ? sequenceOfRecommendLayout : [];
    return {
      ...v,
      header: {
        ..._get(v, 'header'),
        topTabs: {
          onClick: {
            tabColor: _get(v, 'header.topTabs.onClick.tabColor', '#ffffff'),
            textColor: _get(v, 'header.topTabs.onClick.textColor', '#55a8f4'),
          },
          default: {
            tabColor: _get(v, 'header.topTabs.default.tabColor', '#ffffff'),
            textColor: _get(v, 'header.topTabs.default.textColor', '#868fb5'),
          },
          enable: _get(v, 'header.topTabs.enable', false),
        },
      },
      defaultLanguage: v.defaultLanguage || 'enu',
      skincareHtmlResult: {
        ..._get(v, 'skincareHtmlResult'),
        detection: {
          ..._get(v, 'skincareHtmlResult.detection'),
          description: {
            ..._get(v, 'skincareHtmlResult.detection.description'),
            categories:
              _get(v, 'skincareHtmlResult.detection.description.categories') ||
              'age_spot',
            language:
              appLang ||
              _get(v, 'skincareHtmlResult.detection.description.language', {
                label: 'English',
                value: 'enu',
              }),
            i18n: {
              ..._get(
                v,
                'skincareHtmlResult.detection.description.i18n',
                config.resultDetectionDescription
              ),
            },
          },
        },
        productRecommend: {
          ..._get(v, 'skincareHtmlResult.productRecommend'),
          heading: {
            ..._get(v, 'skincareHtmlResult.productRecommend.heading'),
            textI18n: {
              ..._get(
                v,
                'skincareHtmlResult.productRecommend.heading.textI18n'
              ),
              enu: _get(
                v,
                'skincareHtmlResult.productRecommend.heading.textI18n.enu',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              fra: _get(
                v,
                'skincareHtmlResult.productRecommend.heading.textI18n.fra',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              jpn: _get(
                v,
                'skincareHtmlResult.productRecommend.heading.textI18n.jpn',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              cht: _get(
                v,
                'skincareHtmlResult.productRecommend.heading.textI18n.cht',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              chs: _get(
                v,
                'skincareHtmlResult.productRecommend.heading.textI18n.chs',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              kor: _get(
                v,
                'skincareHtmlResult.productRecommend.heading.textI18n.kor',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              deu: _get(
                v,
                'skincareHtmlResult.productRecommend.heading.textI18n.deu',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              esp: _get(
                v,
                'skincareHtmlResult.productRecommend.heading.textI18n.esp',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              ita: _get(
                v,
                'skincareHtmlResult.productRecommend.heading.textI18n.ita',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              ptb: _get(
                v,
                'skincareHtmlResult.productRecommend.heading.textI18n.ptb',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              ara: _get(
                v,
                'skincareHtmlResult.productRecommend.heading.textI18n.ara',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
            },
          },
          enabledInfo: _get(
            v,
            'skincareHtmlResult.productRecommend.enabledInfo'
          )
            ? handleEnabledInfo(
                _get(v, 'skincareHtmlResult.productRecommend.enabledInfo')
              )
            : ['brandName', 'productName', 'productDesc'],
        },
        recommendSummary: {
          ..._get(v, 'skincareHtmlResult.recommendSummary'),
          layoutItems: sequenceOfRecommendLayout.filter(
            r => r.disabled === false
          ),
          layout: sequenceOfRecommendLayout,
          contentI18n: {
            ..._get(v, 'skincareHtmlResult.recommendSummary.contentI18n'),
            enu: _get(
              v,
              'skincareHtmlResult.recommendSummary.contentI18n.enu',
              ''
            )
              .replace('<span>', '')
              .replace('</span>\n', ''),
            fra: _get(
              v,
              'skincareHtmlResult.recommendSummary.contentI18n.fra',
              ''
            )
              .replace('<span>', '')
              .replace('</span>\n', ''),
            jpn: _get(
              v,
              'skincareHtmlResult.recommendSummary.contentI18n.jpn',
              ''
            )
              .replace('<span>', '')
              .replace('</span>\n', ''),
            cht: _get(
              v,
              'skincareHtmlResult.recommendSummary.contentI18n.cht',
              ''
            )
              .replace('<span>', '')
              .replace('</span>\n', ''),
            chs: _get(
              v,
              'skincareHtmlResult.recommendSummary.contentI18n.chs',
              ''
            )
              .replace('<span>', '')
              .replace('</span>\n', ''),
            kor: _get(
              v,
              'skincareHtmlResult.recommendSummary.contentI18n.kor',
              ''
            )
              .replace('<span>', '')
              .replace('</span>\n', ''),
            deu: _get(
              v,
              'skincareHtmlResult.recommendSummary.contentI18n.deu',
              ''
            )
              .replace('<span>', '')
              .replace('</span>\n', ''),
            esp: _get(
              v,
              'skincareHtmlResult.recommendSummary.contentI18n.esp',
              ''
            )
              .replace('<span>', '')
              .replace('</span>\n', ''),
            ita: _get(
              v,
              'skincareHtmlResult.recommendSummary.contentI18n.ita',
              ''
            )
              .replace('<span>', '')
              .replace('</span>\n', ''),
            ptb: _get(
              v,
              'skincareHtmlResult.recommendSummary.contentI18n.ptb',
              ''
            )
              .replace('<span>', '')
              .replace('</span>\n', ''),
            ara: _get(
              v,
              'skincareHtmlResult.recommendSummary.contentI18n.ara',
              ''
            )
              .replace('<span>', '')
              .replace('</span>\n', ''),
          },
        },
        routineRecommend: {
          ..._get(v, 'skincareHtmlResult.routineRecommend'),
          enabledInfo: _get(
            v,
            'skincareHtmlResult.routineRecommend.enabledInfo'
          )
            ? handleEnabledInfo(
                _get(v, 'skincareHtmlResult.routineRecommend.enabledInfo')
              )
            : ['brandName', 'productName', 'productDesc'],
          heading: {
            ..._get(v, 'skincareHtmlResult.routineRecommend.heading'),
            textI18n: {
              ..._get(
                v,
                'skincareHtmlResult.routineRecommend.heading.textI18n'
              ),
              enu: _get(
                v,
                'skincareHtmlResult.routineRecommend.heading.textI18n.enu',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              fra: _get(
                v,
                'skincareHtmlResult.routineRecommend.heading.textI18n.fra',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              jpn: _get(
                v,
                'skincareHtmlResult.routineRecommend.heading.textI18n.jpn',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              cht: _get(
                v,
                'skincareHtmlResult.routineRecommend.heading.textI18n.cht',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              chs: _get(
                v,
                'skincareHtmlResult.routineRecommend.heading.textI18n.chs',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              kor: _get(
                v,
                'skincareHtmlResult.routineRecommend.heading.textI18n.kor',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              deu: _get(
                v,
                'skincareHtmlResult.routineRecommend.heading.textI18n.deu',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              esp: _get(
                v,
                'skincareHtmlResult.routineRecommend.heading.textI18n.esp',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              ita: _get(
                v,
                'skincareHtmlResult.routineRecommend.heading.textI18n.ita',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              ptb: _get(
                v,
                'skincareHtmlResult.routineRecommend.heading.textI18n.ptb',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              ara: _get(
                v,
                'skincareHtmlResult.routineRecommend.heading.textI18n.ara',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
            },
          },
        },
        treatmentRecommend: {
          ..._get(v, 'skincareHtmlResult.treatmentRecommend'),
          enabledInfo: _get(
            v,
            'skincareHtmlResult.treatmentRecommend.enabledInfo'
          )
            ? handleEnabledInfo(
                _get(v, 'skincareHtmlResult.treatmentRecommend.enabledInfo')
              )
            : ['brandName', 'productName', 'productDesc'],
          heading: {
            ..._get(v, 'skincareHtmlResult.treatmentRecommend.heading'),
            textI18n: {
              ..._get(
                v,
                'skincareHtmlResult.treatmentRecommend.heading.textI18n'
              ),
              enu: _get(
                v,
                'skincareHtmlResult.treatmentRecommend.heading.textI18n.enu',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              fra: _get(
                v,
                'skincareHtmlResult.treatmentRecommend.heading.textI18n.fra',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              jpn: _get(
                v,
                'skincareHtmlResult.treatmentRecommend.heading.textI18n.jpn',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              cht: _get(
                v,
                'skincareHtmlResult.treatmentRecommend.heading.textI18n.cht',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              chs: _get(
                v,
                'skincareHtmlResult.treatmentRecommend.heading.textI18n.chs',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              kor: _get(
                v,
                'skincareHtmlResult.treatmentRecommend.heading.textI18n.kor',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              deu: _get(
                v,
                'skincareHtmlResult.treatmentRecommend.heading.textI18n.deu',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              esp: _get(
                v,
                'skincareHtmlResult.treatmentRecommend.heading.textI18n.esp',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              ita: _get(
                v,
                'skincareHtmlResult.treatmentRecommend.heading.textI18n.ita',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              ptb: _get(
                v,
                'skincareHtmlResult.treatmentRecommend.heading.textI18n.ptb',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
              ara: _get(
                v,
                'skincareHtmlResult.treatmentRecommend.heading.textI18n.ara',
                ''
              )
                .replace('<span>', '')
                .replace('</span>\n', ''),
            },
          },
        },
        skinHealth: {
          ..._get(v, 'skincareHtmlResult.skinHealth'),
          summary: {
            ..._get(v, 'skincareHtmlResult.skinHealth.summary'),
            contentLanguage: appLang || {label: 'English', value: 'enu'},
            contentI18n: _get(
              v,
              'skincareHtmlResult.skinHealth.summary.contentI18n',
              config.summaryContent
            ),
          },
        },
      },
      buttons: [
        {
          ..._get(v, 'buttons[0]'),
          textLanguage: appLang || {label: 'English', value: 'enu'},
        },
        {
          ..._get(v, 'buttons[1]'),
          textLanguage: appLang || {label: 'English', value: 'enu'},
        },
      ],
    };
  };

  const formikConfig = {
    enableReinitialize: true,
    initialValues: getInitValue(initValue),
    onSubmit: async (values, {setSubmitting, resetForm}) => {
      setSubmitting(true);
      const processedData = {
        ...values,
        preview: {
          concernOrder: category,
        },
        header: {
          backgroundColor: _get(values, 'header.backgroundColor'),
          borderBottom: {
            width: _get(values, 'header.borderBottom.width'),
            style: _get(values, 'header.borderBottom.style'),
            color: _get(values, 'header.borderBottom.color'),
          },
          backIcon: {
            enabled: true,
            type: 'custom',
            image: {
              id: '',
              url: await handleImage(
                _get(values, 'header.backIcon.image.image'),
                token,
                customerId
              ),
              image: await handleImage(
                _get(values, 'header.backIcon.image.image'),
                token,
                customerId
              ),
            },
          },
          homeIcon: {
            enabled: true,
            type: 'custom',
            image: {
              id: '',
              url: await handleImage(
                _get(values, 'header.homeIcon.image.image'),
                token,
                customerId
              ),
              image: await handleImage(
                _get(values, 'header.homeIcon.image.image'),
                token,
                customerId
              ),
            },
          },
          topTabs: _get(values, 'header.topTabs'),
        },
        skincareHtmlResult: {
          ...values.skincareHtmlResult,
          recommendSummary: {
            ...values.skincareHtmlResult.recommendSummary,
            layout: arrayMappingValue(
              values.skincareHtmlResult.recommendSummary.layout
            ),
            backgroundImage: [
              {
                id: '',
                url: await handleImage(
                  _get(
                    values,
                    'skincareHtmlResult.recommendSummary.backgroundImage[0].image'
                  ),
                  token,
                  customerId
                ),
                image: await handleImage(
                  _get(
                    values,
                    'skincareHtmlResult.recommendSummary.backgroundImage[0].image'
                  ),
                  token,
                  customerId
                ),
              },
              {
                id: '',
                url: await handleImage(
                  _get(
                    values,
                    'skincareHtmlResult.recommendSummary.backgroundImage[1].image'
                  ),
                  token,
                  customerId
                ),
                image: await handleImage(
                  _get(
                    values,
                    'skincareHtmlResult.recommendSummary.backgroundImage[1].image'
                  ),
                  token,
                  customerId
                ),
              },
            ],
          },
          routineRecommend: {
            ...values.skincareHtmlResult.routineRecommend,
            productCard: {
              ...values.skincareHtmlResult.routineRecommend.productCard,
              moreInfoIcon: {
                id: '',
                url: await handleImage(
                  _get(
                    values,
                    'skincareHtmlResult.routineRecommend.productCard.moreInfoIcon.image'
                  ),
                  token,
                  customerId
                ),
                image: await handleImage(
                  _get(
                    values,
                    'skincareHtmlResult.routineRecommend.productCard.moreInfoIcon.image'
                  ),
                  token,
                  customerId
                ),
              },
            },
          },
          productRecommend: {
            ...values.skincareHtmlResult.productRecommend,
            productCard: {
              ...values.skincareHtmlResult.productRecommend.productCard,
              moreInfoIcon: {
                id: '',
                url: await handleImage(
                  _get(
                    values,
                    'skincareHtmlResult.productRecommend.productCard.moreInfoIcon.image'
                  ),
                  token,
                  customerId
                ),
                image: await handleImage(
                  _get(
                    values,
                    'skincareHtmlResult.productRecommend.productCard.moreInfoIcon.image'
                  ),
                  token,
                  customerId
                ),
              },
            },
          },
          treatmentRecommend: {
            ...values.skincareHtmlResult.treatmentRecommend,
            treatmentCard: {
              ...values.skincareHtmlResult.treatmentRecommend.treatmentCard,
              moreInfoIcon: {
                id: '',
                url: await handleImage(
                  _get(
                    values,
                    'skincareHtmlResult.treatmentRecommend.treatmentCard.moreInfoIcon.image'
                  ),
                  token,
                  customerId
                ),
                image: await handleImage(
                  _get(
                    values,
                    'skincareHtmlResult.treatmentRecommend.treatmentCard.moreInfoIcon.image'
                  ),
                  token,
                  customerId
                ),
              },
            },
          },
        },
      };
      const data = {
        ...template,
        langs: [
          {
            ...template.langs[0],
            page: processedData,
          },
        ],
      };

      templateConfigs
        .toResultZip(data)
        .then(async r => {
          setTimeout(async () => {
            const fileId = await zipGenerate(
              r,
              'ResultPage',
              token,
              customerId,
              [
                {
                  fileName: 'result_back.jpg',
                  file: data.langs[0].page.header.backIcon.image.url,
                },
                {
                  fileName: 'result_home.jpg',
                  file: data.langs[0].page.header.homeIcon.image.url,
                },
                {
                  fileName: 'get_result_back.jpg',
                  file:
                    data.langs[0].page.featureConfig.getPhoto.header.backIcon
                      .image.url,
                },
                {
                  fileName: 'get_result_home.jpg',
                  file:
                    data.langs[0].page.featureConfig.getPhoto.header.homeIcon
                      .image.url,
                },
                {
                  fileName:
                    'result_recommendSummary_backgroundImage_mobile.jpg',
                  file:
                    data.langs[0].page.skincareHtmlResult.recommendSummary
                      .backgroundImage[0].image,
                },
                {
                  fileName: 'result_recommendSummary_backgroundImage_pad.jpg',
                  file:
                    data.langs[0].page.skincareHtmlResult.recommendSummary
                      .backgroundImage[1].image,
                },
                {
                  fileName:
                    'result_routineRecommend_productCard_moreInfoIcon.jpg',
                  file:
                    data.langs[0].page.skincareHtmlResult.routineRecommend
                      .productCard.moreInfoIcon.image,
                },
                {
                  fileName:
                    'result_productRecommend_productCard_moreInfoIcon.jpg',
                  file:
                    data.langs[0].page.skincareHtmlResult.productRecommend
                      .productCard.moreInfoIcon.image,
                },
                {
                  fileName:
                    'result_treatmentRecommend_productCard_moreInfoIcon.jpg',
                  file:
                    data.langs[0].page.skincareHtmlResult.treatmentRecommend
                      .treatmentCard.moreInfoIcon.image,
                },
              ]
            );
            await updateTemplate(
              token,
              customerId,
              templateId,
              templateType,
              data,
              fileId
            )
              .then(r => setIsShowPublishModal(true))
              .catch(r => {
                toast.error(
                  <Trans i18nKey="c.f.simple.button.group.failed">failed</Trans>
                );
                setSubmitting(false);
              });
            await setSubmitting(false);
          }, 1000);
        })
        .catch(r => {
          toast.error(
            <Trans i18nKey="c.f.simple.button.group.failed">failed</Trans>
          );
          setSubmitting(false);
        });
    },
  };

  const handleOnChange = () => {
    if (!formRef.current) {
      return;
    }
    const formData = formRef.current.state.values;
    const style = _get(formData, 'templateStyle');
    if (style && style !== theme) {
      if (isFirst) {
        if (style === 'dark') {
          setLightData(formData);
        } else {
          setDarkData(formData);
        }
        setDefault(style);
        setTheme(style);
        setIsFirst(false);
      } else {
        setTheme(style);
        setShowDialog(true);
      }
    }
  };

  const changeTheme = (style, value, setValues, setFieldValue) => {
    setHidePreview(true);
    if (style === 'dark') {
      setLightData(value);
      if (darkData) {
        setValues(darkData);
        setFieldValue('templateStyle', style);
        setShowDialog(false);
      } else {
        setDefault(style);
      }
    } else {
      setDarkData(value);
      if (lightData) {
        setValues(lightData);
        setFieldValue('templateStyle', style);
        setShowDialog(false);
      } else {
        setDefault(style);
      }
    }
    setTimeout(() => {
      setHidePreview(false);
    }, 200);
  };

  const setDefault = style => {
    setHidePreview(true);
    getTemplateDefaultConfig(
      'SmbResultHomePage',
      style.replace(style[0], style[0].toUpperCase()),
      1,
      customerId
    ).then(r => {
      if (r && r.templateMetadata) {
        let data = r.templateMetadata;
        setTemplate(data);
        setInitValue(data.langs[0].page);
        setShowDialog(false);
        setTimeout(() => {
          setHidePreview(false);
        }, 200);
      }
    });
  };

  if (
    !(
      privilegeUtils.canUiConfig(accountSummary) ||
      privilegeUtils.isTechnicalSupport(accountSummary)
    )
  ) {
    history.push('/');
  }

  return isLoaded ? (
    <div>
      <Header />
      <Loader />
    </div>
  ) : (
    <Formik {...formikConfig} ref={formRef}>
      {formikProps => (
        <Form
          className="skincare-configuration-form"
          onChange={() => {
            setTimeout(() => {
              handleOnChange(formikProps.dirty);
            });
          }}
        >
          <Header publishStatus={publishStatus} dirty={formikProps.dirty} />
          <div
            className="skincare-configuration-layout"
            style={{height: 'calc(100% - 170px)'}}
          >
            <div className="skincare-configuration-layout__left">
              <TabSection dirty={formikProps.dirty} />

              <div className="kt-portlet skincare-configuration-layout__left-portlet">
                {/*<div className="text-right" onClick={scrolldiv}>*/}
                {/*  Recommendation*/}
                {/*</div>*/}
                <div className="kt-portlet__body skincare-configuration-layout__left-portlet__body">
                  <div>
                    <h5>
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpage.theme">
                        Result Page Theme
                      </Trans>
                      <div
                        className="kt-margin-t-10"
                        style={{
                          backgroundColor: '#e1e1ef',
                          height: '1px',
                        }}
                      />
                    </h5>
                    <div className="form-group row">
                      {width >= 1366 && (
                        <label className="col-3 col-form-label text-left" />
                      )}
                      <div
                        className={classnames({
                          'col-6': width < 1366,
                          'col-3': width >= 1366,
                        })}
                      >
                        <Field
                          name="templateStyle"
                          label={
                            <Trans i18nKey="p.s.uiconfiguration.skinresultpage.template.light">
                              Light
                            </Trans>
                          }
                          value={'light'}
                          component={RadioButton}
                        />
                        <img
                          src={require('../../../../assets/images/skincare/skincarepro_v1_9report.png')}
                          alt={''}
                          width={'inherit'}
                          style={{width: '90%', boxShadow: '0 0 5px'}}
                        />
                      </div>
                      <div
                        className={classnames({
                          'col-6': width < 1366,
                          'col-3': width >= 1366,
                        })}
                      >
                        <Field
                          name="templateStyle"
                          label={
                            <Trans i18nKey="p.s.uiconfiguration.skinresultpage.template.dark">
                              Dark
                            </Trans>
                          }
                          value={'dark'}
                          component={RadioButton}
                        />
                        <img
                          src={require('../../../../assets/images/skincare/skincarepro_v1_dk_8report.png')}
                          alt={''}
                          width={'inherit'}
                          style={{width: '90%', boxShadow: '0 0 5px'}}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-3 col-form-label text-center">
                        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.default.language">
                          Default Language
                        </Trans>
                      </label>
                      <div
                        className={classnames({
                          'col-4': width >= 768,
                          'col-9': width < 768,
                        })}
                      >
                        <Field
                          name="defaultLanguage"
                          value={_get(formikProps.values, 'defaultLanguage')}
                          component={SelectBox}
                          options={langUtils.getAppLangList()}
                        />
                      </div>
                    </div>
                    <h5>
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpage.page.header">
                        Page Header
                      </Trans>
                      <div
                        className="kt-margin-t-10"
                        style={{
                          backgroundColor: '#e1e1ef',
                          height: '1px',
                        }}
                      />
                    </h5>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.background.color">
                          Background Color
                        </Trans>
                      </label>
                      <div className={width >= 1366 ? 'col-4' : 'col-8'}>
                        <Field
                          name="header.backgroundColor"
                          component={ColorField}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.bottom.border">
                          Bottom Border
                        </Trans>
                      </label>
                      <div
                        className="col-9 col-lg-8 col-md-8"
                        style={{display: width >= 1366 ? 'flex' : 'block'}}
                      >
                        <div
                          className={classnames({
                            'col-3': width > 1024,
                            'col-9': width <= 1024,
                            'kt-margin-b-20': width <= 1024,
                          })}
                        >
                          <Field
                            name="header.borderBottom.color"
                            component={ColorField}
                          />
                        </div>
                        <div
                          className={classnames({
                            'col-3': width >= 1366,
                            'col-9': width < 1366,
                            'kt-margin-b-20': width < 1366,
                          })}
                        >
                          <Field
                            name="header.borderBottom.width"
                            component={SelectBox}
                            options={skinResultPageStyle.getBorderWidthConfigs()}
                          />
                        </div>
                        <div
                          className={classnames({
                            'col-3': width >= 1366,
                            'col-9': width < 1366,
                            'kt-margin-b-20': width < 1366,
                          })}
                        >
                          <Field
                            name="header.borderBottom.style"
                            component={SelectBox}
                            options={skinResultPageStyle.getBorderStyleConfigs()}
                          />
                        </div>{' '}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.back.icon">
                          Back Icon
                        </Trans>
                      </label>
                      <div className="col-4 col-lg-8 col-md-8">
                        <Field
                          name="header.backIcon.image.image"
                          imageUrl={_get(
                            formikProps.values,
                            'header.backIcon.image.image'
                          )}
                          scaleImage={true}
                          clearFormFields={[
                            'header.backIcon.image.image',
                            'header.backIcon.image.url',
                          ]}
                          component={ImageField}
                          width={200}
                          height={200}
                          maxWidth={width > 1024 ? 200 : 100}
                          maxHeight={width > 1024 ? 200 : 100}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.home.icon">
                          Home Icon
                        </Trans>
                      </label>
                      <div className="col-4 col-lg-8 col-md-8">
                        <Field
                          name="header.homeIcon.image.image"
                          imageUrl={_get(
                            formikProps.values,
                            'header.homeIcon.image.image'
                          )}
                          scaleImage={true}
                          clearFormFields={[
                            'header.homeIcon.image.image',
                            'header.homeIcon.image.url',
                          ]}
                          component={ImageField}
                          width={200}
                          height={200}
                          maxWidth={width > 1024 ? 200 : 100}
                          maxHeight={width > 1024 ? 200 : 100}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.enable.recommendation">
                          Enable Recommendation
                        </Trans>
                      </label>
                      <div className="col-9 col-lg-8 col-md-8 m-auto">
                        <Field
                          name="header.topTabs.enable"
                          value={_get(
                            formikProps.values,
                            'header.topTabs.enable'
                          )}
                          component={CustomSwitch}
                        />
                      </div>
                    </div>
                    <h6 className="kt-margin-t-10">
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.top.tabs">
                        Top Tabs
                      </Trans>
                    </h6>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.tabcolor.onclick">
                          Tab Color - On Click
                        </Trans>
                      </label>
                      <div className={width >= 1366 ? 'col-4' : 'col-8'}>
                        <Field
                          name="header.topTabs.onClick.tabColor"
                          component={ColorField}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.textcolor.onclick">
                          Text Color - On Click
                        </Trans>
                      </label>
                      <div className={width >= 1366 ? 'col-4' : 'col-8'}>
                        <Field
                          name="header.topTabs.onClick.textColor"
                          component={ColorField}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.tabcolor.default">
                          Tab Color - Default
                        </Trans>
                      </label>
                      <div className={width >= 1366 ? 'col-4' : 'col-8'}>
                        <Field
                          name="header.topTabs.default.tabColor"
                          component={ColorField}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.textcolor.default">
                          Text Color - Default
                        </Trans>
                      </label>
                      <div className={width >= 1366 ? 'col-4' : 'col-8'}>
                        <Field
                          name="header.topTabs.default.textColor"
                          component={ColorField}
                        />
                      </div>
                    </div>
                  </div>
                  <SkinReport formikProps={formikProps} width={width} />
                  <SkinResultPageFooter props={formikProps} width={width} />
                  <div id="recommendation" />
                  <Recommendation
                    formikProps={formikProps}
                    width={width}
                    displayRecommendLayout={displayRecommendLayout}
                    setImageType={setImageType}
                    imageType={imageType}
                  />
                </div>
                <div className="d-flex justify-content-end kt-margin-t-20">
                  <ButtonWithRestoreGroup
                    saveDirty={formikProps.dirty}
                    discardButton={false}
                    isUpdating={true}
                    onRestoreClick={() => {
                      handleRestore(_get(formikProps.values, 'templateStyle'));
                      formikProps.resetForm();
                    }}
                  />
                </div>
              </div>
            </div>
            {!isLoaded && !hidePreview && template && formikProps.values && (
              <div className="skincare-configuration-layout__right">
                <PreviewModule
                  initValue={initValue}
                  values={formikProps.values}
                  template={{
                    ...template,
                    langs: [
                      {
                        default: template ? template.langs[0].default : true,
                        lang: template ? template.langs[0].langs : 'enu',
                        page: formikProps.values,
                        preview: {
                          concernOrder: category,
                        },
                        sharedPage: template
                          ? template.langs[0].sharedPage
                          : [],
                      },
                    ],
                  }}
                  previewUrl={previewUrl}
                  type={'ResultPage'}
                  onChangeDevice={device => {
                    setImageType(device);
                  }}
                  onChangeLanguage={lang => {
                    formikProps.setFieldValue(
                      'skincareHtmlResult.skinHealth.summary.contentLanguage',
                      lang
                    );
                    formikProps.setFieldValue(
                      'skincareHtmlResult.detection.description.language',
                      lang
                    );
                    formikProps.setFieldValue(
                      'skincareHtmlResult.recommendSummary.contentLanguage',
                      lang
                    );
                    formikProps.setFieldValue(
                      'skincareHtmlResult.productRecommend.heading.textLanguage',
                      lang
                    );
                    formikProps.setFieldValue(
                      'skincareHtmlResult.routineRecommend.heading.textLanguage',
                      lang
                    );
                    formikProps.setFieldValue(
                      'skincareHtmlResult.treatmentRecommend.heading.textLanguage',
                      lang
                    );
                    formikProps.setFieldValue('buttons[0].textLanguage', lang);
                  }}
                  isV2Above={false}
                />
              </div>
            )}
            <UnSavedModal
              type={'theme'}
              showModal={showDialog}
              setShowModal={setShowDialog}
              handleLeave={() =>
                changeTheme(
                  theme,
                  formikProps.values,
                  formikProps.setValues,
                  formikProps.setFieldValue
                )
              }
              handleCancel={() => {
                formikProps.setFieldValue(
                  'templateStyle',
                  theme === 'dark' ? 'light' : 'dark'
                );
                setTheme(theme => (theme === 'dark' ? 'light' : 'dark'));
              }}
            />
          </div>
          <PublishToOnlineModal
            isShow={isShowPublishModal}
            onPublish={isPublish => {
              formikProps.setSubmitting(false);
              formikProps.resetForm(formikProps.values);
              setPublishStatus(isPublish);
              setIsShowPublishModal(false);
            }}
          />
        </Form>
      )}
    </Formik>
  );
}
